module.exports = __webpack_public_path__ + "static/media/opencv.6bb8c58e.svg";